import { Text } from "@fluentui/react-components";
import _ from "lodash";
import { memo } from "react";
import { useAppData } from "../hooks";
import { useCategoriesData } from "../hooks/useCategoriesData";
import { MetaDataSelector } from "./MetadataSelector";

export type GroupedMetadataSelectorProps = {
  selectedOptions: Record<string, string[]>;
  onChange: (selectedOptions: Record<string, string[]>) => void;
  appId: string;
};

export const GroupedMetadataSelector = memo(
  ({ selectedOptions, onChange, appId, ...props }: GroupedMetadataSelectorProps) => {
    const [workspaceId] = useAppData<string>(appId, "workspaceId");

    const { tagCategories } = useCategoriesData(undefined, { workspaceId: workspaceId, includeAll: false });

    const onGroupSelectionChange = (label: string, options: Array<string>) => {
      const newSelectedOptions = {
        ...selectedOptions,
        [label]: options,
      };
      onChange(newSelectedOptions);
    };

    if (_.isEmpty(tagCategories)) {
      return <></>;
    }

    return (
      <>
        {Object.entries(tagCategories).map(([key, value]) => {
          return (
            <MetaDataSelector
              group_id={_.capitalize(key)}
              selected={selectedOptions[key]}
              tags={value}
              key={key}
              label={<Text weight="semibold">{_.startCase(key)}</Text>}
              onSelectedTagsChange={(selectedTags: Array<string>) => onGroupSelectionChange(key, selectedTags)}
              showCategories={false}
              appId={appId}
            />
          );
        })}
      </>
    );
  }
);
